import { Injectable } from '@angular/core'
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'

@Injectable()
export class UkDateAdapter extends NgbDateAdapter<string> {
    private DELIMITER = '-'

    fromModel(value: string | null): NgbDateStruct | null {
        if (!value) return null

        const normalized = value.trim()
        const datePart = normalized.split('T')[0]

        // Accept API ISO dates (yyyy-mm-dd) as well as UI/model dates (dd-mm-yyyy).
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
            const [year, month, day] = datePart.split('-')

            return {
                day: +day,
                month: +month,
                year: +year,
            }
        }

        const [day, month, year] = datePart.split(this.DELIMITER)

        return {
            day: +day,
            month: +month,
            year: +year,
        }
    }

    toModel(date: NgbDateStruct | null): string | null {
        if (!date) return null

        return `${date.year}-${this.pad(date.month)}-${this.pad(date.day)}`
    }

    private pad(n: number) {
        return n < 10 ? `0${n}` : `${n}`
    }
}
